import { Projects } from '@/components/sections/projects';

export function ProjectsPage() {
  return (
    <div className="container">
      <Projects />
    </div>
  );
}